import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Profil } from 'src/app/models/profil.model';
import { ProfilService } from 'src/app/services/profil.service';
import { ValidationService } from 'src/app/services/validation.service';
import { YetkiService } from 'src/app/services/yetki.service';
import { finalize } from 'rxjs';
import jwtDecode from 'jwt-decode';
import { Kullanici } from 'src/app/models/kullanici.model';
import { GirisService } from 'src/app/services/giris.service';

declare var bootstrap: any;
@Component({
  selector: 'profil-islem',
  templateUrl: './profil-islem.component.html',
  styleUrls: ['./profil-islem.component.css']
})
export class ProfilIslemComponent implements OnInit {

  constructor(private profilService: ProfilService,private route: ActivatedRoute, private formBuilder: FormBuilder,private rooting: Router, private validationService: ValidationService,public yetkiService:YetkiService, private girisService: GirisService, private router: Router) { }
  profil: Profil[]=[];
  detayForm = this.formBuilder.group(new Profil());
  smsDogrulaForm=this.formBuilder.group({ dogrulamaKod:[''] });
  yukleniyor = false;
  kaydediliyor = false;
  hatalar: any = {};
  durumlar: any[] = [];
  kullanici: Kullanici = new Kullanici();
  yeni = true;
  smsGelenKod:string='';
  dogrulaniyor=false;
  smsGonderimDurum=false;


  ngOnInit(): void { 
    this.sure=300;
    this.kullanici =this.girisService.girisBilgi(); 
    this.route.params.subscribe(params => {
      if (params['id'] != 'yeni') {
        this.getById(params['id']);
      }
    });   
  }
  
  getById(id: number) {
    this.yukleniyor = true;
    this.yeni = false;
    this.profilService.getById(id).subscribe(res => {
      if(res==null){
        this.router.navigateByUrl('/');
      }
        this.detayForm.patchValue({  
          ...res   
        });   
        this.profil[0]=res; 
        this.yukleniyor = false;
      },err=>{
        this.router.navigateByUrl('/');
      });
    }

  sure=300;
  smsSendModal() {  
    this.smsGonderimDurum=true;
 //   this.sure=0;
    setInterval(()=>{
      this.sure--; 
      if(this.sure==0){
        bootstrap.Modal.getInstance(document.getElementById('sms_modal')).hide();
        clearInterval(this.sure);
       }  
    },1000);
    var kulid: number = +this.girisService.girisBilgi().kullanici_id;
    this.profilService.smsSend().pipe(finalize(() => {
    })).subscribe({
      next: res => {
        if (res?.message && res?.message != "" ) {this.yetkiService.success(res?.message,1)}; 
        document.getElementById('openSmsModalButton')?.click();
        // var myModal = new bootstrap.Modal(document.getElementById('sms_modal'))
        // myModal.show();
      },
      error: err => {
        this.smsGonderimDurum=false;
       
        if (err.error.Errors == undefined || err.error.Errors == null ||err.error.Errors?.length==0){
          if (err.error?.message && err.error?.message != "" ) {this.yetkiService.error(err.error?.message,1)};
          if (err.error?.Message && err.error?.Message != "" ) {this.yetkiService.error(err.error?.Message,1)};
        }
      }
  });

   }

   reloadProfilComponent() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/profil/'+this.girisService.girisBilgi().kullanici_id]);
}
  
   smsKodDogrula() { 
    
    this.dogrulaniyor=true;
    this.smsGelenKod=this.smsDogrulaForm.controls['dogrulamaKod'].value;
    this.profilService.smsCheck(this.smsGelenKod).pipe(finalize(() => {
    })).subscribe({
      next: res => {
        if (res?.message && res?.message != "" ) {   
          this.yetkiService.success(res?.message,1)};
         
          bootstrap.Modal.getInstance(document.getElementById('sms_modal')).hide();
          this.reloadProfilComponent();
          this.dogrulaniyor=false;
      },
      error: err => {
        this.dogrulaniyor=false;
        this.smsGonderimDurum=false;
        if (err.error.Errors == undefined ||err.error.Errors == null ||err.error.Errors?.length==0){
          if (err.error?.message && err.error?.message != "" ) {this.yetkiService.error(err.error?.message,1)};
          if (err.error?.Message && err.error?.Message != "" ) {this.yetkiService.error(err.error?.Message,1)};
        }
      }
  });
}

  kaydetGuncelle() {
    this.kaydediliyor = true;
    this.hatalar = {};
    this.profilService.addUpdate(this.detayForm.value).pipe(finalize(() => {
      this.kaydediliyor = false;
    })).subscribe({
      next: res => {
        if (res?.message && res?.message != "" ) {this.yetkiService.success(res?.message,1)};
      //  this.rooting.navigateByUrl('/profil')
          this.reloadProfilComponent();
      },
      error: err => {
        this.hatalar = this.validationService.hatalar(err.error.Errors);
        if (err.error.Errors == undefined ||err.error.Errors == null ||err.error.Errors?.length==0){
          if (err.error?.message && err.error?.message != "" ) {this.yetkiService.error(err.error?.message,1)};
          if (err.error?.Message && err.error?.Message != "" ) {this.yetkiService.error(err.error?.Message,1)};
          
        }
      }
    });
    
  }

}
